import styled from '@emotion/styled';
import { css_medium_up, css_prop } from '~/emotion/theme';

const Outer = styled.div<{ $height: string; $zindex?: number; $percent: number }>`
	z-index: ${css_prop('$zindex')};
	margin-bottom: calc(${css_prop('$height')} / (-100 / ${css_prop('$percent')}));

	@media (${css_medium_up}) {
		position: relative;
		display: flex;
		align-items: flex-end;
		height: calc(${css_prop('$height')} * (1 + (${css_prop('$percent')} / 100)));
	}
`;

const Inner = styled.div<{ $height: string }>`
	@media (${css_medium_up}) {
		flex: 1;
		position: sticky;
		bottom: 0;
		height: ${css_prop('$height')};

		> * {
			height: ${css_prop('$height')};
		}
	}
`;

export default function MicrositeOffset({
	children,
	height,
	zindex,
	percent = 50,
}: {
	children: React.ReactNode;
	height: string;
	percent?: number;
	zindex?: number;
}) {
	return (
		<Outer $height={height} $zindex={zindex} $percent={percent}>
			<Inner $height={height}>{children}</Inner>
		</Outer>
	);
}
